import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

//fil out empty contaiers for each table, used for easy check if data exists or not
const initialState = {
  timesheetReport: { timesheetData: [], unitData: [], jobData: [] },
  jobReport: {
    jobData: [],
    checklistData: [],
    timesheetData: [],
    unitData: [],
  },
  defectReport: { defectData: [], unitData: [] },
  unitReport: { unitData: [] },
  deliveryReport: { deliveryData: [], unitData: [] },
  checklistReport: { checklistData: [] },
  photoReport: { photoData: [] },
  documentReport: { documentData: [] },
  trainingReport: { trainingData: [] },
  ticketReport: { ticketData: [] },
  taskReport: { taskData: [] },
  workOrders: { workOrderData: [], deletedWorkOrderData: [] },
  ticketsApproval: { timesheetData: [], jobData: [], deliveryData: []  },
  iftaReport: { fuelData: [] },
  customerCardReport: {},
  equipmentCardReport: {},
};

//setting table cache removes any old table cache, to ensure doenst bog down site
const updateTableCache = (action) => {
  let tableKey = action.tableKey;
  let tableValue = action.tableValue;

  return {
    ...initialState,
    [tableKey]: tableValue,
  };
};

const tableCacheReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_TABLECACHE:
      return updateObject(state, {
        ...updateTableCache(action),
        customerCardReport: state.customerCardReport,
        equipmentCardReport: state.equipmentCardReport,
      });
    case actionTypes.RESET_TABLECACHE:
      return initialState;
    case actionTypes.UPDATE_CARD_REPORT_CACHE: {
      const currentOwner = state[action.cardKey]?._ownerId;
      const newOwner = action.ownerId;
      const ownerChanged = newOwner && currentOwner && newOwner !== currentOwner;
      return updateObject(state, {
        [action.cardKey]: {
          ...(ownerChanged ? {} : state[action.cardKey]),
          _ownerId: newOwner || currentOwner,
          [action.subKey]: action.data,
        },
      });
    }
    default:
      return state;
  }
};

export default tableCacheReducer;
